import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {initialize} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router';

import * as types from '../../types/index';
import * as authActions from '../../actions/auth';

import BackButton from '../BackButton';
import AppBlock from '../AppBlock';
import Title from './Title';
import FlashMessage from '../FlashMessage';

const FORM_NAME = 'resendConfirm-form';

class ResendConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resendTimeout: 0
    };

    this.identifierField =
      props.xl.isUsernameEmail || props.xl.proxy.resetPassword ? 'email' : 'username';
  }

  componentDidMount() {
    const initialFormData = {
      [this.identifierField]: this.props.auth.reset[this.identifierField]
    };

    this.props.dispatch(initialize(FORM_NAME, initialFormData));
    this.resetTimer();
  }

  componentWillUnmount() {
    clearInterval(this.state.resendTimeout);
  }

  resetTimer() {
    const intervalId = setInterval(() => {
      const {auth, dispatch} = this.props;

      if (auth.resend.timer > 0) {
        dispatch({type: types.RESEND_CONFIRM_SET_TIMER, count: auth.resend.timer - 1});
      } else {
        clearInterval(this.state.resendTimeout);
      }
    }, 1000);
    this.setState({resendTimeout: intervalId});
  }

  resetResendForm() {
    const {dispatch} = this.props;
    dispatch({type: types.RESEND_CONFIRM_CLEAR});
  }

  handleResend(value) {
    const {xl, dispatch, location} = this.props;

    authActions.resendConfirmAsync(dispatch, value, location.query, xl).then(() => {
      this.resetTimer();
    });
  }

  render() {
    const {
      intl,
      location,
      auth,
      xl: {isIFrame}
    } = this.props;

    return (
      <Fragment>
        <AppBlock>
          <Title
            title={intl.messages['auth-reg.title']}
            backLink={
              <Link
                className="back-link"
                style={{pointerEvents: 'visiblePainted'}}
                to={{pathname: '/', search: location.search}}
                onClick={this.resetResendForm.bind(this)}
              >
                {intl.messages['app.back']}
              </Link>
            }
          />

          <div className="block-content">
            {auth.resend.error !== null && (
              <FlashMessage type="error" message={auth.resend.error} />
            )}
            <div className="content-message">
              <div className="message">
                {intl.formatMessage({id: 'auth-reg.complete'}, {email: auth.resend.email})}
                <br />
                {intl.formatMessage({id: 'auth-reg.check-spam-folder'})}
              </div>

              <div id="resend-confirm" className="form-group">
                {auth.resend.timer === 0 ? (
                  <button
                    className="form-button button-outline"
                    onClick={this.handleResend.bind(this, auth.resend.email)}
                    disabled={auth.resend.loading || auth.resend.timer > 0}
                  >
                    {auth.resend.loading
                      ? intl.messages['form.loading']
                      : intl.messages['auth-reset.resend']}
                  </button>
                ) : (
                  <div className="form-button button-link">
                    {intl.messages['auth-reset.resend']} ({auth.resend.timer})
                  </div>
                )}
              </div>

              {isIFrame && <BackButton isIFrame={isIFrame} />}
            </div>
          </div>
        </AppBlock>
      </Fragment>
    );
  }
}

ResendConfirm.propTypes = {
  auth: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  xl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default injectIntl(connect(mapStateToProps)(ResendConfirm));



// WEBPACK FOOTER //
// ./components/Form/ResendConfirm.jsx